// For internal use to help build the dependency graph with CP rules

/** @deprecated PropertyDefinitionsFetcher is an escape hatch for apps using GQL; please reach out to #crm-properties-frontend before using (https://git.hubteam.com/HubSpot/PropertiesFrontendTeam/issues/955) */
export const INITIALIZING = 'INITIALIZING';
export const INITIALIZATION_FAILED = 'INITIALIZATION_FAILED';